// import Image from "next/image";
import { LoaderFive } from "../ui/loader";

const PageLoading = ({ containerSize = "size-[150px]" }) => {
  return (
    <>
      <div className={`${containerSize} relative overflow-hidden`}>
        {/* <Image
          src="/bin-yaber-assets/loading/bin-yaber-loading.gif"
          alt="Loading..."
          fill
          unoptimized
          className="object-cover"
        /> */}
        <LoaderFive text="Fetching Data..." />
      </div>
    </>
  );
};

export default PageLoading;
